import { CountLogDTO } from "../tsClasses/CHTypes";
import { apiPath } from "./GeneralFunc";

type AddCountLogFuncProps = {
    countLogDTO : CountLogDTO,
    userToken: string,
}

const AddCountLogFunc = async (props : AddCountLogFuncProps) => {
  
    const dataToSend = props.countLogDTO;
  
  
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", token: props.userToken },
      body: JSON.stringify(dataToSend),
    };
    try {
      const response = await fetch(
        apiPath+"/addCountLogDTO",
        requestOptions
      );
      if (response.status == 401) {
        return "Unauthorized";
      }
      if (response == null) {
      }
  
      const result = await response.text();
      return result;
    } catch (error) {
      return "gotErr";
    }
  };
  
  export default AddCountLogFunc;
  